/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Error_Not_Billing_OwnerInputs */



/**
* | output |
* | --- |
* | "Only the account owner can add or change the AI Agent plugin." |
*
* @param {Assistant_Error_Not_Billing_OwnerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_error_not_billing_owner = /** @type {((inputs?: Assistant_Error_Not_Billing_OwnerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Error_Not_Billing_OwnerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seul le propriétaire du compte peut ajouter ou modifier le plugin Agent IA.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur der Kontoinhaber kann das AI Agent-Plugin hinzufügen oder ändern.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo il proprietario dell'account può aggiungere o modificare il plugin AI Agent.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавлять или изменять плагин AI Agent может только владелец учетной записи.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo el propietario de la cuenta puede agregar o modificar el complemento del agente de IA.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("只有账户所有者才能添加或更改 AI Agent 插件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AIエージェントプラグインを追加または変更できるのは、アカウント所有者のみです。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केवल खाताधारक ही एआई एजेंट प्लगइन को जोड़ या बदल सकता है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Somente o proprietário da conta pode adicionar ou alterar o plugin AI Agent.")
	return /** @type {LocalizedString} */ ("Only the account owner can add or change the AI Agent plugin.")
});